import clsx from 'clsx';
import React from 'react';
import { Element } from '../../../atoms';
import Context from '../context';
import styles from '../pagination.styles';

/**
 *
 * @type {import('.').PaginationItemType}
 */
const Item = ({ children, className, page, onClick, disabled, hideActive, ...props }) => {
  const { current } = React.useContext(Context);
  return (
    <Element
      isInteractive
      onClick={disabled ? undefined : onClick}
      {...props}
      data-page={page}
      disabled={disabled}
      className={clsx(styles.item, className, {
        active: !hideActive && page === current,
      })}
    >
      {children}
    </Element>
  );
};

export default Item;
